/**
 * @fileoverview Cookie Consent Banner
 *
 * Purpose: GDPR-style cookie consent banner for marketing pages.
 * Persists dismissal in localStorage so it only shows once.
 * Should only be rendered on public/marketing pages, not inside the app.
 */

import { useState, useEffect } from "react";
import { Button } from "@/ui/primitives";
import { Link } from "@tanstack/react-router";

const STORAGE_KEY = "morgan_cookie_consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show if user hasn't already accepted
    if (!localStorage.getItem(STORAGE_KEY)) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] duration-300 animate-in fade-in slide-in-from-bottom-4">
      <div className="mx-auto max-w-5xl px-4 pb-4">
        <div className="flex flex-col items-center gap-4 rounded-xl border border-border/60 bg-card/95 px-6 py-4 shadow-lg backdrop-blur-sm sm:flex-row sm:justify-between">
          <p className="text-center text-sm text-muted-foreground sm:text-left">
            We use cookies to personalise content, run ads, &amp; analyse
            traffic.{" "}
            <Link
              to="/privacy"
              className="font-medium text-primary underline-offset-4 hover:underline"
            >
              Learn more
            </Link>
          </p>
          <Button size="sm" onClick={handleAccept} className="shrink-0">
            Okay
          </Button>
        </div>
      </div>
    </div>
  );
}
